import { NextRequest, NextResponse } from 'next/server';

/**
 * Middleware route handler for the AGNT Inc. home page.
 * Runs at the edge — just passes the request through.
 * Actual SSR data fetching happens in src/pages/index.tsx.
 */
export function homeRouteHandler(_req: NextRequest): NextResponse {
  return NextResponse.next();
}
